module.exports = __webpack_public_path__ + "img/MASERATI.9059fe1.jpg";